<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="名称"
        v-model="listQuery.key"
      ></el-input>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.status"
      >
        <el-option label="全部状态" :value="99"></el-option>
        <el-option label="正常" :value="0"></el-option>
        <el-option label="冻结" :value="-1"></el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.role"
      >
        <el-option label="全部角色" :value="99"></el-option>
        <el-option label="超级管理员" :value="0"></el-option>
        <el-option
          v-for="item in roles"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="info"
        icon="el-icon-search"
        @click="doSearch"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset"
        >重置</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="showAddDialog"
        >添加</el-button
      >
    </div>
    <el-table
      :data="list"
      v-loading="listLoading"
      fit
      border
      highlight-current-row
      style="width: 100%"
      max-height="550"
    >
      <el-table-column align="left" label="账户名" min-width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.account }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="名称" min-width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="工号" min-width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.empNo }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="账户类型">
        <template slot-scope="scope">
          <span>{{ scope.row.isSuper | superUserFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="角色" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.roleName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="邮箱" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="最后访问时间">
        <template slot-scope="scope">
          <span>{{
            scope.row.lastLoginTime | parseTime("{y}-{m}-{d} {h}:{i}")
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        class-name="status-col"
        align="center"
        label="状态"
        width="110"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status | statusDisplay
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="
              scope.row.account != currentAccount &&
              scope.row.account != 'admin' &&
              scope.row.account != 'wc_admin' &&
              scope.row.account != 'hy_admin'
            "
            size="mini"
            @click="showEditDialog(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="
              scope.row.account != currentAccount &&
              scope.row.account != 'admin' &&
              scope.row.account != 'wc_admin' &&
              scope.row.account != 'hy_admin'
            "
            type="warning"
            size="mini"
            @click="toDelete(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="添加操作员"
      :visible.sync="newDialogVisible"
      width="1300px"
    >
      <div class="boxs">
        <div class="box1">
          <el-form
            ref="newForm"
            :model="newUser"
            :rules="newFormRules"
            label-position="right"
            label-width="120px"
          >
            <el-form-item label="账户名" prop="account">
              <el-input
                style="width: 200px"
                v-model="newUser.account"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <el-input style="width: 200px" v-model="newUser.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input style="width: 200px" v-model="newUser.phone"></el-input>
            </el-form-item>
            <el-form-item label="超级管理员">
              <el-checkbox
                v-model="newUser.isSuper"
                @change="newisSuper"
              ></el-checkbox>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input style="width: 200px" v-model="newUser.email"></el-input>
            </el-form-item>
            <el-form-item v-if="newUser.isSuper == false" label="角色">
              <el-select
                style="width: 200px"
                class="filter-item"
                v-model="newUser.roleId"
              >
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="box2">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="商家类型" v-if="businessType === 0">
              <el-select
                style="width: 200px"
                class="filter-item"
                multiple
                collapse-tags
                @remove-tag="removeAddTag"
                @change="dealerAddChange"
                v-model="newUser2.dealerTypes"
              >
                <el-option
                  :label="item.name"
                  :value="item.value"
                  v-for="(item, index) in dealerTypes"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否脱敏">
              <el-radio v-model="newUser2.hidePhoneDisplay" :label="true"
                >是</el-radio
              >
              <el-radio v-model="newUser2.hidePhoneDisplay" :label="false"
                >否</el-radio
              >
            </el-form-item>
            <el-form-item label="展厅线索">
              <el-radio v-model="newUser2.allowStoreClue" :label="true"
                >是</el-radio
              >
              <el-radio v-model="newUser2.allowStoreClue" :label="false"
                >否</el-radio
              >
            </el-form-item>
            <el-form-item label="概览显示">
              <el-radio v-model="newUser2.allowDashboard" :label="true"
                >是</el-radio
              >
              <el-radio v-model="newUser2.allowDashboard" :label="false"
                >否</el-radio
              >
            </el-form-item>
            <el-form-item label="区域:" style="margin-bottom: 5px">
              <el-col :span="8">
                <el-select
                  style="width: 200px"
                  class="filter-item"
                  v-model="newUser2.viewType"
                  @change="changeViewType"
                >
                  <el-option label="所有" :value="0"></el-option>
                  <el-option label="战区" :value="1"></el-option>
                  <el-option label="大区" :value="2"></el-option>
                  <el-option label="区域" :value="3"></el-option>
                  <el-option label="门店" :value="4"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="车系:" style="margin-top: 25px">
              <el-checkbox
                v-model="newUser2.isSpecificSeries"
                @change="checkBox(1)"
                >全选</el-checkbox
              >
              <el-select
                class="filter-item"
                style="width: 180px"
                multiple
                v-model="newUser2.series"
                filterable
                placeholder="请选择车系"
                v-show="!newUser2.isSpecificSeries"
              >
                <el-option
                  v-for="item in seriesOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台:" style="margin-top: 25px">
              <el-checkbox
                v-model="newUser2.isSpecificSource"
                @change="checkBox(2)"
                >全选</el-checkbox
              >
              <el-select
                class="filter-item"
                style="width: 150px"
                multiple
                v-model="newUser2.source"
                filterable
                placeholder="请选择平台渠道"
                v-show="!newUser2.isSpecificSource"
              >
                <el-option
                  v-for="item in importSources"
                  :key="item.dataName"
                  :label="item.dataDisplay"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经销商等级:" style="margin-top: 25px">
              <el-select
                style="width: 200px"
                multiple
                class="filter-item"
                v-model="newUser2.dealerLevels"
                placeholder="经销商等级"
              >
                <el-option
                  v-for="item in salesLevels"
                  :key="item.dataName"
                  :label="item.dataName"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="pure-u-1-2">
          <div style="height: 400px; overflow: auto">
            <el-tree
              v-show="newUser2.viewType != 0"
              :data="treeData"
              show-checkbox
              ref="tree"
              node-key="value"
              :props="defaultProps"
            ></el-tree>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doAddUser">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑操作员"
      :visible.sync="editDialogVisible"
      width="1300px"
    >
      <div class="boxs">
        <div class="box1">
          <el-form
            ref="editForm"
            :model="editUser"
            :rules="newFormRules"
            label-position="right"
            label-width="120px"
          >
            <el-form-item label="账户名" prop="account">
              <el-input
                style="width: 200px"
                v-model="editUser.account"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
              <el-input style="width: 200px" v-model="editUser.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input
                style="width: 200px"
                v-model="editUser.phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="超级管理员">
              <el-checkbox
                v-model="editUser.isSuper"
                @change="editisSuper"
              ></el-checkbox>
            </el-form-item>
            <el-form-item v-if="editUser.isSuper == false" label="角色">
              <el-select
                style="width: 200px"
                class="filter-item"
                v-model="editUser.roleId"
              >
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input
                style="width: 200px"
                v-model="editUser.email"
              ></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select
                style="width: 200px"
                class="filter-item"
                v-model="editUser.status"
              >
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="-1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="密码">
              <el-button type="info" plain @click="resetPassword"
                >重置密码</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="box2">
          <el-form label-position="left" label-width="80px">
            <el-form-item label="商家类型" v-if="businessType === 0">
              <el-select
                style="width: 200px"
                class="filter-item"
                multiple
                collapse-tags
                @remove-tag="removeEditTag"
                @change="dealerEditChange"
                v-model="editUser2.dealerTypes"
              >
                <el-option
                  :label="item.name"
                  :value="item.value"
                  v-for="(item, index) in dealerTypes"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否脱敏">
              <el-radio v-model="editUser2.hidePhoneDisplay" :label="true"
                >是</el-radio
              >
              <el-radio v-model="editUser2.hidePhoneDisplay" :label="false"
                >否</el-radio
              >
            </el-form-item>
            <el-form-item label="展厅线索">
              <el-radio v-model="editUser2.allowStoreClue" :label="true"
                >是</el-radio
              >
              <el-radio v-model="editUser2.allowStoreClue" :label="false"
                >否</el-radio
              >
            </el-form-item>
            <el-form-item label="概览显示">
              <el-radio v-model="editUser2.allowDashboard" :label="true"
                >是</el-radio
              >
              <el-radio v-model="editUser2.allowDashboard" :label="false"
                >否</el-radio
              >
            </el-form-item>
            <el-form-item label="区域:" style="margin-bottom: 5px">
              <el-col :span="8">
                <el-select
                  style="width: 200px"
                  class="filter-item"
                  v-model="editUser2.viewType"
                  @change="changeViewType"
                >
                  <el-option label="所有" :value="0"></el-option>
                  <el-option label="战区" :value="1"></el-option>
                  <el-option label="大区" :value="2"></el-option>
                  <el-option label="区域" :value="3"></el-option>
                  <el-option label="门店" :value="4"></el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="车系:" style="margin-top: 25px">
              <el-checkbox
                v-model="editUser2.isSpecificSeries"
                @change="checkBox(3)"
                >全选</el-checkbox
              >
              <el-select
                class="filter-item"
                style="width: 180px"
                multiple
                v-model="editUser2.series"
                filterable
                placeholder="请选择车系"
                v-show="!editUser2.isSpecificSeries"
              >
                <el-option
                  v-for="item in seriesOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="平台:" style="margin-top: 25px">
              <el-checkbox
                v-model="editUser2.isSpecificSource"
                @change="checkBox(4)"
                >全选</el-checkbox
              >
              <el-select
                class="filter-item"
                style="width: 150px"
                multiple
                v-model="editUser2.source"
                filterable
                placeholder="请选择平台渠道"
                v-show="!editUser2.isSpecificSource"
              >
                <el-option
                  v-for="item in importSources"
                  :key="item.dataName"
                  :label="item.dataDisplay"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经销商等级:" style="margin-top: 25px">
              <el-select
                style="width: 200px"
                multiple
                class="filter-item"
                v-model="editUser2.dealerLevels"
                placeholder="经销商等级"
              >
                <el-option
                  v-for="item in salesLevels"
                  :key="item.dataName"
                  :label="item.dataName"
                  :value="item.dataName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="pure-u-1-2">
          <div style="height: 400px; overflow: auto">
            <el-tree
              v-show="editUser2.viewType != 0"
              :data="treeData"
              show-checkbox
              ref="tree"
              node-key="value"
              :props="defaultProps"
            ></el-tree>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doUpdate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "SystemUserList",
  data() {
    return {
      currentAccount: "",
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        key: "",
        status: 99,
        role: 99,
      },
      roles: [],

      newDialogVisible: false,
      newUser: {
        account: "",
        name: "",
        isSuper: false,
        roleId: "",
        email: "",
      },
      newUser2: {
        dealerTypes: ["全部", 1, 2],
        hidePhoneDisplay: true,
        allowStoreClue: true,
        allowDashboard: true,
        viewType: 0, // 区域
        views: [], // 权限集合
        isSpecificSeries: true, // 是否指定车系
        series: [], // 指定车系id
        source: [], // 指定平台字符串
        isSpecificSource: true, // 是否指定平台
        dealerLevels: [],
      },
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      bigAreaOptions: [], // 大区数据
      salesCenterOptions: [], // 营销中心数据
      areaOptions: [], // 区域数据
      codeOptions: [], // 门店数据
      seriesOptions: [], // 车系数据,
      importSources: [], // 渠道数据
      editDialogVisible: false,
      editUser: {
        id: 0,
        account: "",
        name: "",
        isSuper: false,
        roleId: "",
        email: "",
        status: 0,
      },
      editUser2: {
        dealerTypes: [],
        hidePhoneDisplay: true,
        allowStoreClue: true,
        allowDashboard: true,
        viewType: 0, // 区域
        views: [], // 权限集合
        isSpecificSeries: true, // 是否指定车系
        series: [], // 指定车系id
        source: [], // 指定平台字符串
        isSpecificSource: true, // 是否指定平台
        dealerLevels: [],
      },

      newFormRules: {
        account: [
          {
            required: true,
            message: "请输入账户名",
            trigger: "blur",
          },
          {
            min: 4,
            max: 20,
            message: "长度应在4-20位",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "长度应在2-20位",
            trigger: "blur",
          },
        ],
      },
      dealerTypes: [{ value: 6, name: "对公" }],
      salesLevels: [
        { dataName: "4S" },
        { dataName: "4S(A)" },
        { dataName: "4S(B)" },
        { dataName: "专营店" },
        { dataName: "体验中心" },
        { dataName: "商超" },
        { dataName: "商超店" },
        { dataName: "城市体验店" },
        { dataName: "城市展厅" },
        { dataName: "销售展厅" },
      ],
      businessType: store.getters.user.businessType,
    };
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: "success",
        1: "info",
      };
      return statusMap[status];
    },
    statusDisplay(status) {
      const statusMap = {
        0: "正常",
        "-1": "冻结",
      };
      return statusMap[status];
    },
    superUserFilter(isSuper) {
      if (isSuper == true) {
        return "超级";
      } else {
        return "普通";
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (
      from.path.indexOf("/user/add") != -1 ||
      from.path.indexOf("/user/edit") != -1
    ) {
      to.meta.refresh = true;
    }
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.doReset();
    this.retrieveCodeOptions();
    this.currentAccount = store.getters.user.account;
  },
  methods: {
    editisSuper(val) {
      if (!val) {
        this.editUser.roleId = "";
      }
    },
    newisSuper(val) {
      if (!val) {
        this.newUser.roleId = "";
      }
    },
    changeViewType(val) {
      this.$refs.tree.setCheckedKeys([]);
      if (val == 2) {
        // 大区
        this.treeData = this.bigAreaOptions;
      }
      if (val == 3) {
        // 区域
        this.treeData = this.areaOptions;
      }
      if (val == 4) {
        // 门店
        this.treeData = this.codeOptions;
      }
      if (val == 1) {
        // 营销中心
        this.treeData = this.salesCenterOptions;
      }
    },
    checkBox(val) {
      switch (val) {
        case 1:
          if (this.newUser2.isSpecificSeries) {
            this.newUser2.series = [];
          }
          break;
        case 2:
          if (this.newUser2.isSpecificSource) {
            this.newUser2.source = [];
          }
          break;
        case 3:
          if (this.editUser2.isSpecificSeries) {
            this.editUser2.series = [];
          }
          break;
        case 4:
          if (this.editUser2.isSpecificSource) {
            this.editUser2.source = [];
          }
          break;

        default:
          break;
      }
    },
    removeEditTag(val) {
      if (val === "全部") {
        this.editUser2.dealerTypes = [];
      }
    },
    removeAddTag(val) {
      if (val === "全部") {
        this.newUser2.dealerTypes = [];
      }
    },
    selectEditAll() {
      if (this.editUser2.dealerTypes.length < this.dealerTypes.length) {
        this.editUser2.dealerTypes = [];
        this.dealerTypes.map((item) => {
          this.editUser2.dealerTypes.push(item.value);
        });
        this.editUser2.dealerTypes.unshift("全部");
      } else {
        this.editUser2.dealerTypes = [];
      }
    },
    selectAddAll() {
      if (this.newUser2.dealerTypes.length < this.dealerTypes.length) {
        this.newUser2.dealerTypes = [];
        this.dealerTypes.map((item) => {
          this.newUser2.dealerTypes.push(item.value);
        });
        this.newUser2.dealerTypes.unshift("全部");
      } else {
        this.newUser2.dealerTypes = [];
      }
    },
    dealerEditChange(val) {
      // if (!val.includes("全部") && val.length === this.dealerTypes.length) {
      //   this.editUser2.dealerTypes.unshift("全部");
      // } else if (
      //   val.includes("全部") &&
      //   val.length - 1 < this.dealerTypes.length
      // ) {
      //   this.editUser2.dealerTypes = this.editUser2.dealerTypes.filter(item => {
      //     return item !== "全部";
      //   });
      // }
    },
    dealerAddChange(val) {
      // if (!val.includes("全部") && val.length === this.dealerTypes.length) {
      //   this.newUser2.dealerTypes.unshift("全部");
      // } else if (
      //   val.includes("全部") &&
      //   val.length - 1 < this.dealerTypes.length
      // ) {
      //   this.newUser2.dealerTypes = this.newUser2.dealerTypes.filter(item => {
      //     return item !== "全部";
      //   });
      // }
    },
    retrieveSalesCenterOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/salesCenterJsonTree", {})
        .then(function (response) {
          parent.salesCenterOptions = response.data.data;
        });
    },
    retrieveBigAreaOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/bigAreaJsonTree", {})
        .then(function (response) {
          parent.bigAreaOptions = response.data.data;
        });
    },
    retrieveAreaOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/areaJsonTree", {})
        .then(function (response) {
          parent.areaOptions = response.data.data;
        });
    },
    retrieveCodeOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/areaJsonTree", { haveDealer: true })
        .then(function (response) {
          parent.codeOptions = response.data.data;
        });
    },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendVehicleRpc/validSeriesList", {})
        .then(function (response) {
          parent.seriesOptions = response.data.records;
        });
    },
    retrieveSystemData() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDictionaryRpc/getDictionaries", {
          category: "IMPORT_SOURCE",
        })
        .then(function (response) {
          parent.importSources = response.data.data;
        })
        .catch(() => {});
    },
    doReset() {
      this.list = null;
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        key: "",
        status: 99,
        role: 99,
      };
      this.doSearch();
    },
    retrieveRoles() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendRoleRpc/list", {
          pageStart: 0,
          pageCount: 1000,
          status: 0,
          businessType: this.businessType,
          roleType: 1
        })
        .then(function (response) {
          parent.roles = response.data.data;
        });
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      var parent = this;
      this.$httpAuth
        .post("/v1/backendOperatorRpc/list", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          key: this.listQuery.key,
          role: this.listQuery.role,
          businessType: this.businessType,
        })
        .then(function (response) {
          parent.listLoading = false;
          parent.list = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    toDelete(id) {
      this.$confirm("是否删除该用户?", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var parent = this;
        this.$httpAuth
          .post("/v1/backendOperatorRpc/delete", {
            id: id,
          })
          .then(function (response) {
            parent.$message({
              message: "删除成功",
              type: "success",
            });
            parent.getList();
          });
      });
    },
    showAddDialog() {
      this.retrieveBigAreaOptions();
      this.retrieveSalesCenterOptions();
      this.retrieveAreaOptions();
      // this.retrieveCodeOptions();
      this.retrieveSeriesOptions();
      this.retrieveSystemData();
      this.retrieveRoles();
      this.newDialogVisible = true;
      this.newUser = {
        account: "",
        name: "",
        isSuper: false,
        roleId: "",
      };
      this.newUser2 = {
        hidePhoneDisplay: true,
        allowStoreClue: true,
        allowDashboard: true,
        viewType: 0,
        isSpecificSeries: true,
        series: [],
        isSpecificSource: true,
        source: [],
        views: [], // 权限集合
        dealerTypes: [6],
        dealerLevels: [],
      };
      if (this.$refs["newForm"]) {
        this.$refs["newForm"].resetFields();
      }
    },
    doAddUser() {
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          var roleId = 0;
          if (this.newUser.roleId != "") {
            roleId = this.newUser.roleId;
          }
          switch (this.newUser2.viewType) {
            case 4:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 4) {
                  viewObj.salesCenter = node.value.split(",")[0];
                  viewObj.bigArea = node.value.split(",")[1];
                  viewObj.area = node.value.split(",")[2];
                  viewObj.code = node.value.split(",")[3];
                  this.newUser2.views.push(viewObj);
                }
              }
              break;
            case 3:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 3) {
                  debugger;
                  viewObj.salesCenter = node.value.split(",")[0];
                  viewObj.bigArea = node.value.split(",")[1];
                  viewObj.area = node.value.split(",")[2];
                  this.newUser2.views.push(viewObj);
                }
              }
              break;
            case 2:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 2) {
                  viewObj.salesCenter = node.value.split(",")[0];
                  viewObj.bigArea = node.value.split(",")[1];
                  this.newUser2.views.push(viewObj);
                }
              }
              break;
            case 1:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 1) {
                  viewObj.salesCenter = node.value;
                  this.newUser2.views.push(viewObj);
                }
              }
              break;

            default:
              break;
          }
          const dealerTypes = this.newUser2.dealerTypes;
          dealerTypes.forEach((item, index) => {
            if (item === "全部") {
              dealerTypes.splice(index, 1);
            }
          });
          var parent = this;
          this.$httpAuth
            .post("/v1/backendOperatorRpc/add", {
              account: this.newUser.account,
              name: this.newUser.name,
              phone: this.newUser.phone,
              roleId: roleId,
              isSuper: this.newUser.isSuper,
              email: this.newUser.email,
              hidePhoneDisplay: this.newUser2.hidePhoneDisplay,
              allowStoreClue: this.newUser2.allowStoreClue,
              allowDashboard: this.newUser2.allowDashboard,
              viewType: this.newUser2.viewType,
              views: this.newUser2.views,
              isSpecificSeries: !this.newUser2.isSpecificSeries,
              seriesIds: this.newUser2.series.join(","),
              isSpecificSource: !this.newUser2.isSpecificSource,
              sourceNames: this.newUser2.source.join(","),
              dealerTypes: dealerTypes.length != 0 ? dealerTypes.join(",") : "",
              dealerLevels:
                this.newUser2.dealerLevels.length != 0
                  ? this.newUser2.dealerLevels.join(",")
                  : "",
            })
            .then(function (response) {
              parent.getList();
              parent.newDialogVisible = false;
            });
        }
      });
    },
    showEditDialog(row) {
      this.retrieveBigAreaOptions();
      this.retrieveSalesCenterOptions();
      this.retrieveAreaOptions();

      this.retrieveSeriesOptions();
      this.retrieveSystemData();
      this.retrieveRoles();
      this.editUser = {
        id: row.id,
        account: row.account,
        name: row.name,
        isSuper: row.isSuper,
        roleId: row.roleId,
        status: row.status,
        email: row.email,
        phone: row.phone,
      };
      var series = [];
      if (row.seriesIds !== "") {
        row.seriesIds.split(",").forEach((item) => {
          series.push(Number(item));
        });
      }
      this.editUser2 = {
        hidePhoneDisplay: row.hidePhoneDisplay,
        allowStoreClue: row.allowStoreClue,
        allowDashboard: row.allowDashboard,
        viewType: row.viewType,
        dealerLevels: row.dealerLevels != "" ? row.dealerLevels.split(",") : [],
        views: row.views,
        isSpecificSeries: !row.isSpecificSeries,
        series: series,
        source: [],
        isSpecificSource: !row.isSpecificSource,
        dealerTypes: [],
      };
      let editData = JSON.parse(JSON.stringify(row));
      if (editData.dealerTypes != "") {
        editData.dealerTypes = editData.dealerTypes.split(",");
        for (let index = 0; index < editData.dealerTypes.length; index++) {
          editData.dealerTypes[index] = Number(editData.dealerTypes[index]);
        }
      } else {
        editData.dealerTypes = [];
      }
      this.editUser2.dealerTypes = editData.dealerTypes;
      this.dealerEditChange(this.editUser2.dealerTypes);
      if (row.sourceNames !== "") {
        this.editUser2.source = row.sourceNames.split(",");
      }
      setTimeout(() => {
        switch (row.viewType) {
          case 1:
            var selectedNodes = [];
            this.treeData = this.salesCenterOptions;
            row.views.forEach((item) => {
              selectedNodes.push(item.salesCenter);
              this.$refs.tree.setCheckedKeys(selectedNodes);
            });
            break;
          case 2:
            var selectedNodes = [];
            this.treeData = this.bigAreaOptions;
            row.views.forEach((item) => {
              selectedNodes.push(item.salesCenter + "," + item.bigArea);
              this.$refs.tree.setCheckedKeys(selectedNodes);
            });
            break;
          case 3:
            var selectedNodes = [];
            this.treeData = this.areaOptions;
            row.views.forEach((item) => {
              selectedNodes.push(
                item.salesCenter + "," + item.bigArea + "," + item.area
              );
              this.$refs.tree.setCheckedKeys(selectedNodes);
            });
            break;
          case 4:
            var selectedNodes = [];
            this.treeData = this.codeOptions;
            row.views.forEach((item) => {
              selectedNodes.push(
                item.salesCenter +
                  "," +
                  item.bigArea +
                  "," +
                  item.area +
                  "," +
                  item.code
              );
              this.$refs.tree.setCheckedKeys(selectedNodes);
            });
            break;

          default:
            break;
        }
      }, 1000);
      this.editDialogVisible = true;
      if (this.$refs["editForm"]) {
        this.$refs["editForm"].resetFields();
      }
    },
    doUpdate() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          var roleId = 0;
          if (this.editUser.roleId != "") {
            roleId = this.editUser.roleId;
          }
          var views = [];

          switch (this.editUser2.viewType) {
            case 4:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 4) {
                  viewObj.salesCenter = node.value.split(",")[0];
                  viewObj.bigArea = node.value.split(",")[1];
                  viewObj.area = node.value.split(",")[2];
                  viewObj.code = node.value.split(",")[3];
                  views.push(viewObj);
                }
              }
              break;
            case 3:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 3) {
                  viewObj.salesCenter = node.value.split(",")[0];
                  viewObj.bigArea = node.value.split(",")[1];
                  viewObj.area = node.value.split(",")[2];
                  views.push(viewObj);
                }
              }
              break;
            case 2:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 2) {
                  viewObj.salesCenter = node.value.split(",")[0];
                  viewObj.bigArea = node.value.split(",")[1];
                  views.push(viewObj);
                }
              }
              break;
            case 1:
              var nodes = this.$refs.tree.getCheckedNodes();
              for (var i = 0; i < nodes.length; i++) {
                var viewObj = {
                  salesCenter: "", // 营销中心
                  bigArea: "", // 大区
                  area: "", // 区域
                  code: "", //门店
                };
                var node = nodes[i];
                if (node.level == 1) {
                  viewObj.salesCenter = node.value;
                  views.push(viewObj);
                }
              }
              break;

            default:
              break;
          }
          const dealerTypes = this.editUser2.dealerTypes;
          dealerTypes.forEach((item, index) => {
            if (item === "全部") {
              dealerTypes.splice(index, 1);
            }
          });
          var parent = this;
          this.$httpAuth
            .post("/v1/backendOperatorRpc/update", {
              id: this.editUser.id,
              account: this.editUser.account,
              name: this.editUser.name,
              phone: this.editUser.phone,
              roleId: roleId,
              isSuper: this.editUser.isSuper,
              status: this.editUser.status,
              email: this.editUser.email,
              hidePhoneDisplay: this.editUser2.hidePhoneDisplay,
              allowStoreClue: this.editUser2.allowStoreClue,
              allowDashboard: this.editUser2.allowDashboard,
              viewType: this.editUser2.viewType,
              views: views,
              isSpecificSeries: !this.editUser2.isSpecificSeries,
              seriesIds: this.editUser2.series.join(","),
              isSpecificSource: !this.editUser2.isSpecificSource,
              sourceNames: this.editUser2.source.join(","),
              dealerTypes: dealerTypes.length != 0 ? dealerTypes.join(",") : "",
              dealerLevels:
                this.editUser2.dealerLevels.length != 0
                  ? this.editUser2.dealerLevels.join(",")
                  : "",
            })
            .then(function (response) {
              parent.getList();
              parent.editDialogVisible = false;
            });
        }
      });
    },
    resetPassword() {
      this.$confirm("是否重置密码为默认密码?", "提示", {
        confirmButtonText: "确定重置",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var parent = this;
        this.$httpAuth
          .post("/v1/backendOperatorRpc/resetPassword", {
            id: parent.editUser.id,
          })
          .then(function (response) {
            parent.$message({
              message: "密码重置成功",
              type: "success",
            });
          });
      });
    },
  },
};
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}

.boxs {
  display: flex;
}

.box2 {
  margin-left: 40px;
}
</style>
